interface DisabledFieldProps extends React.HTMLAttributes<HTMLSpanElement> {
  isDisabled: boolean
}
export const DisabledField = ({
  className,
  isDisabled,
  ...props
}: DisabledFieldProps) => {
  const disabledClass = isDisabled
    ? "tw-bg-gray-50 tw-flex !tw-h-full tw-items-center tw-text-gray-400 tw-pointer-events-none [&>*]:!tw-text-gray-400 [&>*]:tw-font-normal [&_.tw-text-text]:tw-text-gray-400"
    : ""
  return (
    <span
      className={`${disabledClass} ${className}`}
      {...props}
    >
      {props.children}
    </span>
  )
}
